import React from 'react';

import { Grid, Typography } from '@mui/material';

import ProvAttacks from './ProvAttacks';
import {
  AttacksByProvince,
  KingdomAttacksByProvince,
} from '../../@types/KingdomNews';

interface KingdomProvAttacksProps {
  kingdom: KingdomAttacksByProvince;
  ownKd?: boolean;
  label: string;
}

const KingdomProvAttacks: React.FC<KingdomProvAttacksProps> = ({
  kingdom,
  ownKd,
  label,
}) => {
  return (
    <Grid
      key={kingdom.kingdomReference}
      style={{ display: 'flex', flexDirection: 'column' }}
      size={{
        lg: 3,
        md: 4,
        sm: 6,
        xs: 12
      }}>
      <Typography
        variant='body1'
        gutterBottom
        component='div'
        sx={{ fontWeight: 'bold' }}
      >
        {label} {kingdom.kingdomReference}
      </Typography>
      <Typography variant='body1' gutterBottom component='div'>
        Total Acres: {kingdom.totalAcresChanged} ({kingdom.totalAttacksMade}/
        {kingdom.totalAttacksSuffered})
      </Typography>
      {kingdom.attacksByProvinces
        .sort((a, b) => b.acresChanged - a.acresChanged)
        .map((p: AttacksByProvince) => (
          <ProvAttacks key={p.provinceName} province={p} />
        ))}
    </Grid>
  );
};

export default KingdomProvAttacks;
